module.exports = "/_next/static/images/611318b5147f0b151bbdbd02c8259f41-cucuta-perks-md-1x.jpg.webp";